import {
  AddressType,
  PutCustomProfessionType,
  PutProfessionType,
  PutUserCocType,
  PutUserDOBType,
  PutUserPaymentConcentType,
  UserType,
  putFormalitiesType,
} from "src/types";
import { instance } from "./helpers/axios";
import { formatToastErrors } from "@utils/toast-errors";
import axios from "axios";

export const getUserDetails = async () => {
  try {
    const { data } = await instance.get("/users/me");
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

export const updateUserDetails = async (
  payload:
    | UserType
    | Pick<UserType, "aov_date_of_birth" | "date_of_birth">
    | Pick<UserType, "first_name" | "last_name" | "email" | "phone_number">
    | PutProfessionType
    | PutUserCocType
    | PutUserPaymentConcentType
    | PutCustomProfessionType
    | putFormalitiesType
    | PutUserDOBType
) => {
  try {
    const { data } = await instance.patch("/users/me", payload);
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

export const createUserAddress = async (payload: AddressType) => {
  try {
    const { data } = await instance.post("/addresses", payload);
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

export const updateUserAddress = async (
  payload: AddressType,
  currentAddressId: string
) => {
  try {
    const { data } = await instance.patch(
      `/addresses/${currentAddressId}`,
      payload
    );
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

export const requestUserLogin = async (email: string) => {
  try {
    const { data } = await instance.post("/magic-link", { email: email });
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

export const requestUserPartners = async (email: string) => {
  try {
    const { data } = await instance.get("/magic-link", { params: { email } });
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

export const requestUserLoginForExternalAccount = async (
  email: string,
  partner_domain: string
) => {
  try {
    const updatedURL = `https://${partner_domain ?? ""}/api/magic-link`.replace(
      /(https?:\/\/[^.]+)(\.)/,
      "$1-connect$2"
    );
    const { data } = await axios.post(updatedURL, { email: email });
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};

let addressLookupController: any = null;
export const requestAddressLookup = async (
  postal_code: string,
  house_number: string
) => {
  try {
    if (addressLookupController) {
      addressLookupController.abort();
    }
    addressLookupController = new AbortController();
    const { data } = await instance.get("/address-lookup/search", {
      params: { postal_code, house_number },
      signal: addressLookupController.signal,
    });
    return data;
  } catch (err: any) {
    throw formatToastErrors(err);
  }
};
